import React from 'react';
import Popup from '../../Popups/Popup';
import PanelSection from '../../FormElements/PanelSection';
import PopupWithUseClickOutside from '../../Popups/PopupWithUseClickOutside';
import EditUserPersonalDataForm from '../UserProfileEditForms/EditUserPersonalDataForm';
import EditUserCustomDataForm from '../UserProfileEditForms/EditUserCustomDataForm';
import EditUserLoginDataForm from '../UserProfileEditForms/EditUserLoginDataForm';
import EditUserLearningPlanExamsDataForm from '../UserProfileEditForms/EditUserLearningPlanExamsDataForm';
import UserLoginData from '../UserProfileData/UserLoginData';
import UserPersonalData from '../UserProfileData/UserPersonalData';
import UserCustomData from '../UserProfileData/UserCustomData';
import UserLearningPlanExamsData from '../UserProfileData/UserLearningPlanExamsData';
import SeparatedItemsList from '../../FormElements/SeparatedItemsList';
import LoaderOverlay from '../../LoaderOverlay/LoaderOverlay';
import MyTranscript from '../../MyTranscript/MyTranscript';
import Label from '../../FormElements/Label';
import Switch from '../../FormElements/Switch';

export default class UserProfileCard extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isUserLoginDataEditCardPopupVisible: false,
			isUserPersonalDataEditCardPopupVisible: false,
			isUserCustomDataEditCardPopupVisible: false,
			isUserLearningPlanExamsEditCardPopupVisible: false,
			isSuccessCardPopupVisible: false,
			isTimeoutCardPopupVisible: false,
			isLoading: false,
			isReportable:
				this.props.userData &&
				this.props.userData.summaryData &&
				this.props.userData.summaryData.isReportable,
			isSection1Visible: true,
			isSection2Visible: true,
			isSection3Visible: true
		};
	}

	componentDidUpdate(prevProps) {
		if (
			Object.keys(prevProps.userData.personalData).length === 0 &&
			Object.keys(this.props.userData.personalData).length > 0
		) {
			const { userData } = this.props;
			const { cdxIdData } = userData;
			// console.log("UserProfileCard - componentDidUpdate", userData);
			$.ajax({
				type: 'POST',
				url:
					this.props.save_personal_data_endpoint +
					'/' +
					cdxIdData['ffg.app.user.id'],
				data: {
					personalData: JSON.stringify(this.props.userData.personalData)
				}
			}).done((data) => {
				// console.log("save_personal_data done", data);
			});
		}

		// Separate if statement for isReportable check
		if (
			prevProps.userData.summaryData.isReportable !==
			this.props.userData.summaryData.isReportable
		) {
			this.setState({
				isReportable: this.props.userData.summaryData.isReportable
			});
		}
	}

	renderLoginDataSection() {
		return (
			<div className="row">
				<div className="col-12">
					<UserLoginData
						title={I18n.t('admin.user_profile.login_details')}
						summaryData={this.props.userData.summaryData}
						loginData={this.props.userData.loginData}
						onShowUserLoginDataEditCardPopup={
							this.onShowUserLoginDataEditCardPopup
						}
					/>
				</div>
			</div>
		);
	}

	renderPersonalDataSection() {
		return (
			<div className="row">
				<div className="col-12">
					<UserPersonalData
						title={I18n.t('admin.user_profile.personal_details')}
						personalData={this.props.userData.personalData}
						onShowUserPersonalDataEditCardPopup={
							this.onShowUserPersonalDataEditCardPopup
						}
					/>
				</div>
			</div>
		);
	}

	renderCustomDataSection() {
		return (
			<div className="row">
				<div className="col-12">
					<UserCustomData
						title={I18n.t('admin.user_profile.custom_details')}
						customData={this.props.userData.customData}
						onShowUserCustomDataEditCardPopup={
							this.onShowUserCustomDataEditCardPopup
						}
					/>
				</div>
			</div>
		);
	}

	renderLearningPlanExamsSection() {
		return (
			<div className="row">
				<div className="col-12">
					{this.props.loading ? null : (
						<UserLearningPlanExamsData
							title={I18n.t('admin.user_profile.learning_plan_exams')}
							user_learning_plans={this.props.userData.userLearningPlans}
							lock_unlock_assessment_endpoint={
								this.props.lock_unlock_assessment_endpoint
							}
							score_released_assessment_endpoint={
								this.props.score_released_assessment_endpoint
							}
							permissionsHelper={this.props.permissionsHelper}
						/>
					)}
				</div>
			</div>
		);
	}

	renderTranscriptSection() {
		return (
			<div className="UserPersonalInfo">
				{this.props.loading ? null : (
					<PanelSection
						title={I18n.t('transcript').toUpperCase()}
						hideEditLink={true}
					>
						<MyTranscript
							courses={this.props.courses}
							personalData={this.props.userData.personalData}
							is_admin={true}
							user_learning_plans={this.props.userData.userLearningPlans}
							user_assessments={this.props.userData.userAssessments}
						/>
					</PanelSection>
				)}
			</div>
		);
	}

	renderSections() {
		if (
			this.state.isSection1Visible &&
			this.state.isSection2Visible &&
			this.state.isSection3Visible
		) {
			return (
				<div>
					{this.props.permissionsHelper.isOnlyProctor() ? null : (
						this.renderLoginDataSection()
					)}
					{this.props.permissionsHelper.isOnlyProctor() ? null : (
						this.renderPersonalDataSection()
					)}
					{this.props.permissionsHelper.isOnlyProctor() ? null : (
						this.renderCustomDataSection()
					)}
					{this.renderLearningPlanExamsSection()}
					{this.props.permissionsHelper.isOnlyProctor() ? null : (
						this.renderTranscriptSection()
					)}
				</div>
			);
		} else if (
			this.state.isSection1Visible &&
			!this.state.isSection2Visible &&
			!this.state.isSection3Visible
		) {
			return (
				<div>
					{this.renderLoginDataSection()}
					{this.renderPersonalDataSection()}
					{this.renderCustomDataSection()}
				</div>
			);
		} else if (
			!this.state.isSection1Visible &&
			this.state.isSection2Visible &&
			!this.state.isSection3Visible
		) {
			return (
				<div>
					{this.props.permissionsHelper.permissions ? null : (
						this.renderLearningPlanExamsSection()
					)}
				</div>
			);
		} else if (
			!this.state.isSection1Visible &&
			!this.state.isSection2Visible &&
			this.state.isSection3Visible
		) {
			return (
				<div>
					{this.props.permissionsHelper.permissions ? null : (
						this.renderTranscriptSection()
					)}
				</div>
			);
		} else {
			return null;
		}
	}

	renderSideNavigation() {
		const {
			isSection1Visible,
			isSection2Visible,
			isSection3Visible
		} = this.state;

		if (
			this.props.loading ||
			isSection1Visible == null ||
			isSection2Visible == null
		) {
			return null;
		}

		return (
			<div>
				{this.props.permissionsHelper.permissions ? null : (
					<div className="UserNav">
						<div className="title-container">
							<span className="title">
								{I18n.t('admin.user_profile_side_nav.title')}
							</span>
						</div>
						<ul className="links-container">
							<li
								className={`link ${isSection1Visible &&
								isSection2Visible &&
								isSection3Visible
									? 'active'
									: ''}`}
								onClick={this.onClickShowAllSections}
							>
								{I18n.t('admin.user_profile_side_nav.all_section')}
							</li>
							<li
								className={`link ${isSection1Visible &&
								!isSection2Visible &&
								!isSection3Visible
									? 'active'
									: ''}`}
								onClick={this.onClickShowSection1}
							>
								{I18n.t('admin.user_profile_side_nav.general_section')}
							</li>
							<li
								className={`link ${!isSection1Visible &&
								isSection2Visible &&
								!isSection3Visible
									? 'active'
									: ''}`}
								onClick={this.onClickShowSection2}
							>
								{I18n.t(
									'admin.user_profile_side_nav.learning_plan_exams_section'
								)}
							</li>
							<li
								className={`link ${!isSection1Visible &&
								!isSection2Visible &&
								isSection3Visible
									? 'active'
									: ''}`}
								onClick={this.onClickShowSection3}
							>
								{I18n.t('admin.user_profile_side_nav.transcript_section')}
							</li>
						</ul>
					</div>
				)}
			</div>
		);
	}

	render() {
		// console.log('UserProfileCard - Props', this.props);
		// console.log('UserProfileCard - State', this.state);
		const { userData } = this.props;

		return (
			<div className="UserProfileCard card">
				<div className="card-body">
					<div className="row">
						<div className="col-10" style={{ position: 'relative' }}>
							<h1 className="username">{this.props.determineDisplayName()}</h1>
							<h2 className="account-type">
								{' '}
								<SeparatedItemsList
									items={
										userData.summaryData &&
										userData.summaryData.summary &&
										userData.summaryData.summary.roles
									}
									property="displayAs"
								/>
							</h2>
							{(userData.summaryData &&
								userData.summaryData.summary &&
								this.props.permissionsHelper.isOnlyProctor()) ||
							this.props.loading ? null : (
								<div
									style={{
										display: 'block',
										position: 'absolute',
										right: 15,
										top: 5
									}}
								>
									<div
										style={{
											margin: '5px 10px 0px 0px',
											display: 'inline-block'
										}}
									>
										<Label>{I18n.t('admin.user_profile.is_reportable')}</Label>
									</div>
									<div style={{ display: 'inline-block' }}>
										<Switch
											isOn={this.state.isReportable}
											handleToggle={this.handleToggleReportable}
											id="is-reportable"
											style={{ marginTop: '-2px' }}
										/>
									</div>
								</div>
							)}
						</div>
					</div>
					<div className="row">
						{/* Main Content */}
						<div className="col-10">{this.renderSections()}</div>

						{/* Side Navigation */}
						{this.props.loading ? null : this.state.isSection1Visible !==
							undefined &&
						this.state.isSection2Visible !== undefined &&
						this.state.isSection3Visible !== undefined ? (
							<div className="col-2">{this.renderSideNavigation()}</div>
						) : null}
					</div>
				</div>

				{/* Show loading overlay when loading */}
				{this.props.loading && <LoaderOverlay />}
				{this.state.isLoading && <LoaderOverlay />}

				{/* User Login Data Edit Popup */}
				<PopupWithUseClickOutside
					isPopupVisible={this.state.isUserLoginDataEditCardPopupVisible}
					onHidePopup={this.onHideUserLoginDataEditCardPopup}
				>
					<Popup
						title={
							<h1 className="card-title">
								{I18n.t('admin.user_profile.update_user_profile_title', {
									userName:
										userData &&
										userData.summaryData &&
										userData.summaryData.summary &&
										userData.summaryData.summary.sortingName
								})}
							</h1>
						}
						onHidePopup={this.onHideUserLoginDataEditCardPopup}
					>
						<EditUserLoginDataForm
							userId={this.props.userId}
							userData={userData}
							iam_get_user_login_endpoint={
								this.props.iam_get_user_login_endpoint
							}
							iam_get_user_roles_endpoint={
								this.props.iam_get_user_roles_endpoint
							}
							iam_update_user_roles_endpoint={
								this.props.iam_update_user_roles_endpoint
							}
							iam_update_user_profile_endpoint={
								this.props.iam_update_user_profile_endpoint
							}
							onHidePopup={this.onHideUserLoginDataEditCardPopup}
							onShowSuccessCardPopup={this.onShowSuccessCardPopup}
							updateRolesData={this.props.updateRolesData}
							updateLoginData={this.props.updateLoginData}
						/>
					</Popup>
				</PopupWithUseClickOutside>

				{/* User Personal Data Edit Popup */}
				<PopupWithUseClickOutside
					isPopupVisible={this.state.isUserPersonalDataEditCardPopupVisible}
					onHidePopup={this.onHideUserPersonalDataEditCardPopup}
				>
					<Popup
						title={
							<h1 className="card-title">
								{I18n.t('admin.user_profile.update_user_profile_title', {
									userName:
										userData &&
										userData.summaryData &&
										userData.summaryData.summary &&
										userData.summaryData.summary.sortingName
								})}
							</h1>
						}
						onHidePopup={this.onHideUserPersonalDataEditCardPopup}
					>
						<EditUserPersonalDataForm
							userId={this.props.userId}
							userData={userData}
							iam_get_user_personal_endpoint={
								this.props.iam_get_user_personal_endpoint
							}
							iam_update_user_profile_endpoint={
								this.props.iam_update_user_profile_endpoint
							}
							onHidePopup={this.onHideUserPersonalDataEditCardPopup}
							onShowSuccessCardPopup={this.onShowSuccessCardPopup}
							updatePersonalData={this.props.updatePersonalData}
						/>
					</Popup>
				</PopupWithUseClickOutside>

				{/* User Custom Data Edit Popup */}
				<PopupWithUseClickOutside
					isPopupVisible={this.state.isUserCustomDataEditCardPopupVisible}
					onHidePopup={this.onHideUserCustomDataEditCardPopup}
				>
					<Popup
						title={
							<h1 className="card-title">
								{I18n.t('admin.user_profile.update_user_profile_title', {
									userName:
										userData &&
										userData.summaryData &&
										userData.summaryData.summary &&
										userData.summaryData.summary.sortingName
								})}
							</h1>
						}
						onHidePopup={this.onHideUserCustomDataEditCardPopup}
					>
						<EditUserCustomDataForm
							userId={this.props.userId}
							userData={userData}
							iam_get_user_custom_endpoint={
								this.props.iam_get_user_custom_endpoint
							}
							iam_update_user_profile_endpoint={
								this.props.iam_update_user_profile_endpoint
							}
							onHidePopup={this.onHideUserCustomDataEditCardPopup}
							onShowSuccessCardPopup={this.onShowSuccessCardPopup}
							updateCustomData={this.props.updateCustomData}
						/>
					</Popup>
				</PopupWithUseClickOutside>

				{/* User Learning Plan Exams Edit Popup */}
				<PopupWithUseClickOutside
					isPopupVisible={
						this.state.isUserLearningPlanExamsEditCardPopupVisible
					}
					onHidePopup={this.onHideUserLearningPlanExamsEditCardPopup}
				>
					<Popup
						title={
							<h1 className="card-title">
								{I18n.t('admin.user_profile.update_learning_plan_exams_title', {
									userName: 'User Name Here'
								})}
							</h1>
						}
						onHidePopup={this.onHideUserLearningPlanExamsEditCardPopup}
					>
						<EditUserLearningPlanExamsDataForm
							user_learning_plan_exams_endpoint={
								this.props.user_learning_plan_exams_endpoint
							}
							lock_unlock_exam_endpoint={this.props.lock_unlock_exam_endpoint}
						/>
					</Popup>
				</PopupWithUseClickOutside>

				{/* Success Popup */}
				<PopupWithUseClickOutside
					isPopupVisible={this.state.isSuccessCardPopupVisible}
					onHidePopup={this.onHideSuccessCardPopup}
				>
					<Popup
						title={
							<h1 className="card-title" style={{ color: 'green' }}>
								{I18n.t('success_card_title')}
							</h1>
						}
						body={I18n.t('admin.user_profile.success_update_user_profile')}
						onHidePopup={this.onHideSuccessCardPopup}
					/>
				</PopupWithUseClickOutside>

				{/* Timeout Popup */}
				<PopupWithUseClickOutside
					isPopupVisible={this.state.isTimeoutCardPopupVisible}
					onHidePopup={this.onHideTimeoutCardPopup}
				>
					<Popup
						title={
							<h1 className="card-title" style={{ color: 'red' }}>
								{I18n.t('timeout_card_title')}
							</h1>
						}
						body={I18n.t('timeout_card_body')}
						onHidePopup={this.onHideTimeoutCardPopup}
					/>
				</PopupWithUseClickOutside>
			</div>
		);
	}

	// Popup functions
	onShowUserLoginDataEditCardPopup = () => {
		this.setState({
			isUserLoginDataEditCardPopupVisible: true
		});
	};

	onHideUserLoginDataEditCardPopup = () => {
		this.setState({
			isUserLoginDataEditCardPopupVisible: false
		});
	};

	onShowUserPersonalDataEditCardPopup = () => {
		this.setState({
			isUserPersonalDataEditCardPopupVisible: true
		});
	};

	onHideUserPersonalDataEditCardPopup = () => {
		this.setState({
			isUserPersonalDataEditCardPopupVisible: false
		});
	};

	onShowUserCustomDataEditCardPopup = () => {
		this.setState({
			isUserCustomDataEditCardPopupVisible: true
		});
	};

	onHideUserCustomDataEditCardPopup = () => {
		this.setState({
			isUserCustomDataEditCardPopupVisible: false
		});
	};

	onShowUserLearningPlanExamsEditCardPopup = () => {
		this.setState({
			isUserLearningPlanExamsEditCardPopupVisible: true
		});
	};

	onHideUserLearningPlanExamsEditCardPopup = () => {
		this.setState({
			isUserLearningPlanExamsEditCardPopupVisible: false
		});
	};

	// Additional popup functions
	onShowSuccessCardPopup = () => {
		this.setState({
			isSuccessCardPopupVisible: true
		});
	};

	onHideSuccessCardPopup = () => {
		this.setState({
			isSuccessCardPopupVisible: false
		});
	};

	onShowTimeoutCardPopup = () => {
		this.setState({
			isTimeoutCardPopupVisible: true
		});
	};

	onHideTimeoutCardPopup = () => {
		this.setState({
			isTimeoutCardPopupVisible: false
		});
	};

	// Section functions
	onClickShowAllSections = () => {
		this.setState({
			isSection1Visible: true,
			isSection2Visible: true,
			isSection3Visible: true
		});
	};

	onClickShowSection1 = () => {
		this.setState({
			isSection1Visible: true,
			isSection2Visible: false,
			isSection3Visible: false
		});
	};

	onClickShowSection2 = () => {
		this.setState({
			isSection1Visible: false,
			isSection2Visible: true,
			isSection3Visible: false
		});
	};

	onClickShowSection3 = () => {
		this.setState({
			isSection1Visible: false,
			isSection2Visible: false,
			isSection3Visible: true
		});
	};

	// IsReportable switch functions
	handleToggleReportable = (e) => {
		const newIsReportable = !this.state.isReportable;
		this.setState({ isReportable: newIsReportable }, () => {
			this.onChangeUpdateIsReportableStatus(e);
		});
	};

	onChangeUpdateIsReportableStatus = (e) => {
		// console.log(
		// 	'Editing User Profile - IsReportable	data,
		// 	this.props.update_user_personal_endpoint
		// );
		e.preventDefault();
		e.stopPropagation();

		this.setState({
			isLoading: true
		});

		$.ajax({
			type: 'POST',
			url: this.props.iam_update_is_reportable_endpoint,
			data: {
				user_id: this.props.userId,
				isReportable: this.state.isReportable
			},
			dataType: 'json'
		}).done((data) => {
			// console.log('Done!', data.status);
			if (data.status === 'success') {
				// console.log('User Profile - Personal Data updated!', data);
				this.setState({
					isLoading: false
				});
				// window.location.reload();
				// this.onShowSuccessCardPopup();
			} else if (data.status == 'session_expired') {
				// console.log('Session expired!');
				this.props.onHidePopup();
				this.props.onShowTimeoutCardPopup(
					setTimeout(() => {
						window.location.href = `/admin/${this.props.public_id}/signin`;
					}, 5000)
				);
			} else {
				// console.log('User Profile - IsReportable data update failed!', data);
				this.setState({
					isLoading: false,
					globalErrors: data.data.global,
					fieldErrors: data.data.fields
				});
			}
		});
	};
}
